import {IUserJson} from "../../../../../../nodeserver/structs/database";
import JSX from "../../../helpers/react.js";
import {ServerApi} from "../../../api.js";
import {handleFetchError} from "../../../helpers/functions.js";
import {FilterAnimeGetParams, UsersSearchGetParams} from "../../../../../../nodeserver/structs/getparams";
import RefObject = JSX.RefObject;
import UserColumn from "../../UserColumn.js";

function UsersData({users, filters}: {users: IUserJson[], filters: UsersSearchGetParams}){
    const container:RefObject<HTMLDivElement> = {};
    const button: RefObject<HTMLButtonElement> = {};
    let fullyLoaded: boolean = users.length < 24;
    return (
        <>
            <div className="grid-container" ref={container}>
                {
                    ...users.map(
                        user=>UserColumn({user})
                    )
                }
                <gap />
                <gap />
                <gap />
            </div>
            <div className="center" style={{marginTop: "10px"}}>
                <button className="main-button load-more bordered" ref={button} style={fullyLoaded?{display: 'none'}:''} onClick={async ()=> !fullyLoaded && (fullyLoaded=(await loadMore(button.value!, container.value!, filters))!)}>Показать ещё</button>
            </div>
        </>
    );
}
async function loadMore(btn: HTMLButtonElement, container: HTMLDivElement, filters: UsersSearchGetParams){
    if(btn.classList.contains('blocked')) return;
    btn.classList.add('blocked');
    btn.innerText = '';
    btn.appendChild(<div><i className="loading" /> Загрузка</div>)
    try {
        const {items: animes} = await ServerApi.users.filter(filters);
        let lastGap: Element|null = container.children[container.childElementCount-1]!;
        while (lastGap?.tagName === 'GAP' && lastGap.previousElementSibling?.tagName === 'GAP')
            lastGap = lastGap.previousElementSibling!
        for(const a of animes.reverse())
            container.insertBefore( <UserColumn user={a}/>, lastGap);
        (filters.offset as number) += 24;
        const fullyLoaded = animes.length < 24;
        if(fullyLoaded) btn.style.display='none';
        return fullyLoaded;
    }
    catch (e){
        handleFetchError(e);
        return false;
    }
    finally {
        btn.classList.remove('blocked');
        btn.innerText = 'Показать ещё';
    }
}
export function FilterUsersPage({users, filters}: {users: IUserJson[], filters: UsersSearchGetParams}){
    if(!users.length) return (
        <div>
            <div className="center">
                Никого не найдено. <br/>
                Попробуйте изменить фильтр.
            </div>
        </div>
    );
    return (
        <div>
            <h1>Поиск пользователей</h1>
            <UsersData users={users} filters={filters}/>
        </div>
    );

}